package space.resolvingcode.tableNavigator

import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.html.*
import kotlinx.html.stream.createHTML
import org.w3c.dom.*

external class Object {
    companion object {
        fun keys(obj : dynamic) : Array<String>
    }
}

external class console {
    companion object {
        fun log(msg : String)
    }
}

fun setTheme(theme : String) {
    document.documentElement!!.setAttribute("data-bs-theme", theme)
}

fun addThemeEvent() {
    document.getElementById("btn_light")!!.addEventListener("click", {setTheme("light")})
    document.getElementById("btn_dark")!!.addEventListener("click", {setTheme("dark")})
}

fun loadSurveys() {
    window.fetch(surveyInfoPath).then { res ->
        res.text()
    }.then { txt ->
        surveyInfo = JSON.parse(txt)
        val surveyNames = Object.keys(surveyInfo)
        val surveyList = document.getElementById("surveyList")

        for (sName in surveyNames) {
            val sInfo = surveyInfo[sName].unsafeCast<Array<String>>()
            val radioEl = document.createElement("input")
            radioEl.apply {
                setAttribute("class", "btn-check")
                setAttribute("type", "radio")
                setAttribute("name", "surveyName")
                setAttribute("id", "s${sInfo[0]}")
                setAttribute("value", sInfo[0])
            }
            val labelEl = document.createElement("label")
            labelEl.apply {
                setAttribute("class", "btn btn-outline-secondary")
                setAttribute("for", "s${sInfo[0]}")
                append(sName)
            }
            surveyList!!.run {
                append(radioEl)
                append(labelEl)
            }
            radioEl.addEventListener("click", { onClickSurvey(sInfo[1], sInfo.sliceArray(2..<sInfo.size)) })
        }
        val sFirst = surveyInfo[surveyNames.first()].unsafeCast<Array<String>>()
        document.querySelector("#s${sFirst[0]}").unsafeCast<HTMLInputElement>().checked = true
        onClickSurvey(sFirst[1], sFirst.sliceArray(2..<sFirst.size))

    }.catch { e ->
        console.log(e.toString())
    }
}

fun onClickSurvey(desc: String, year: Array<String>) {
    document.getElementById("surveyInfo")!!.innerHTML = desc
    val sYears = document.createElement("div")
    sYears.setAttribute("class", "py-4 w-75 btn-group-vertical")
    sYears.setAttribute("id", "surveyYear")
    for (y in year) {
        val radioEl = document.createElement("input")
        radioEl.apply {
            setAttribute("class", "btn-check")
            setAttribute("type", "radio")
            setAttribute("name", "surveyYear")
            setAttribute("id", "y$y")
            setAttribute("value", y)
        }
        val labelEl = document.createElement("label")
        labelEl.apply {
            setAttribute("class", "btn btn-outline-secondary")
            setAttribute("for", "y$y")
            append(y)
        }
        sYears.run {
            append(radioEl)
            append(labelEl)
        }
    }
    document.getElementById("surveyYear")!!.replaceWith(sYears)
    document.querySelector("#y${year[0]}").unsafeCast<HTMLInputElement>().checked = true
}

fun selectSurvey() {
    val surveyID = document.querySelector("input[name='surveyName']:checked")!!.unsafeCast<HTMLInputElement>().value
    val surveyYear = document.querySelector("input[name='surveyYear']:checked")!!.unsafeCast<HTMLInputElement>().value
    window.fetch(tblIDbyItemPath(surveyID, surveyYear)).then { res ->
        res.text()
    }.then { txt ->
        tblIDbyItem = JSON.parse(txt)
        val itemNames = Object.keys(tblIDbyItem)

        document.getElementById("itemList")!!.innerHTML = createHTML().div {
            role = "group"
            for (idx in itemNames.indices) {
                radioInput(classes = "btn-check", name = "itemBtn") {
                    id = "items$idx"
                    value = itemNames[idx]
                }
                label(classes = "m-2 px-2 btn btn-outline-secondary") {
                    attributes["for"] = "items$idx"
                    +itemNames[idx]
                }
            }
        }
        document.getElementById("itemBtn")!!.setAttribute("class", "btn btn-primary")
        document.getElementById("surveyBtn")!!.scrollIntoView(ScrollIntoViewOptions(
            block = ScrollLogicalPosition.CENTER,
            behavior = ScrollBehavior.SMOOTH))
    }.catch { e ->
        console.log(e.toString())
    }

    document.getElementById("grpList")!!.innerHTML = ""
    document.getElementById("grpEnums")!!.innerHTML = ""
    document.getElementById("grpBadges")!!.innerHTML = ""
    document.getElementById("tables")!!.innerHTML = ""
    document.getElementById("itemNameMirror")!!.innerHTML = ""

    window.fetch(tblIDbyGroupPath(surveyID, surveyYear)).then { res ->
        res.text()
    }.then { txt ->
        tblIDbyGroup = JSON.parse(txt)
    }.catch { e ->
        console.log(e.toString())
    }
    window.fetch(grpByItemPath(surveyID, surveyYear)).then { res ->
        res.text()
    }.then { txt ->
        grpByItem = JSON.parse(txt)
    }.catch { e ->
        console.log(e.toString())
    }
    window.fetch(grpInfoPath(surveyID, surveyYear)).then { res ->
        res.text()
    }.then { txt ->
        grpInfo = JSON.parse(txt)
    }.catch { e ->
        console.log(e.toString())
    }
    window.fetch(tblTitlePath(surveyID, surveyYear)).then { res ->
        res.text()
    }.then { txt ->
        tblTitles = JSON.parse(txt)
    }.catch { e ->
        console.log(e.toString())
    }
}

fun showGroupInfo(grpName : String) {
    val grpEnums = grpInfo[grpName].unsafeCast<Array<String>>()
    val enumEl = document.createElement("ul")
    enumEl.apply {
        setAttribute("class", "list-group overflow-auto text-nowrap rounded bg-dark-subtle")
        setAttribute("id", "grpEnums")
        setAttribute("style", "height: 400px;")
    }
    for (enum in grpEnums) {
        val enEl = document.createElement("li")
        enEl.append(enum)
        enumEl.append(enEl)
    }
    document.getElementById("grpEnums")!!.replaceWith(enumEl)
}

fun selectItem() {
    val selectedItem = document.querySelector("input[name='itemBtn']:checked").unsafeCast<HTMLInputElement?>()
    if (selectedItem != null) {
        currentItem = selectedItem.value
        currentGrp.clear()

        document.getElementById("grpList")!!.innerHTML = ""
        document.getElementById("grpEnums")!!.innerHTML = ""
        document.getElementById("grpBadges")!!.innerHTML = ""
        document.getElementById("tables")!!.innerHTML = ""
        document.getElementById("itemNameMirror")!!.innerHTML = "表章項目：$currentItem"

        val grpNames = grpByItem[currentItem].unsafeCast<Array<String>>()
        for (idx in grpNames.indices) {
            val radioEl = document.createElement("input")
            radioEl.apply {
                setAttribute("class", "btn-check")
                setAttribute("type", "radio")
                setAttribute("name", "grpBtn")
                setAttribute("id", "grp$idx")
                setAttribute("value", grpNames[idx])
            }
            val labelEl = document.createElement("label")
            labelEl.apply {
                setAttribute("class", "m-2 px-2 btn btn-outline-secondary")
                setAttribute("for", "grp$idx")
                append(grpNames[idx])
            }
            document.getElementById("grpList")!!.run {
                append(radioEl)
                append(labelEl)
            }
            radioEl.addEventListener("click", { showGroupInfo(grpNames[idx]) })
        }
        document.getElementById("itemBtn")!!.scrollIntoView(ScrollIntoViewOptions(
                block = ScrollLogicalPosition.START,
                behavior = ScrollBehavior.SMOOTH))

    }
}

fun selectGrp() {
    val selectedGrp = document.querySelector("input[name='grpBtn']:checked").unsafeCast<HTMLInputElement?>()
    if (selectedGrp != null) {
        currentGrp.add(selectedGrp.value)
        selectedGrp.checked = false

        val btnEl = document.createElement("button")
        btnEl.setAttribute("class", "btn-close btn-primary")
        val badgeEl = document.createElement("span")
        badgeEl.apply {
            setAttribute("class", "p-2 border rounded")
            insertAdjacentHTML("beforeend", createHTML().span("px-1") { +selectedGrp.value })
            insertAdjacentHTML("beforeend", createHTML().span("badge") { })
            querySelector(".badge")!!.append(btnEl)
        }
        document.getElementById("grpBadges")!!.append(badgeEl)
        btnEl.addEventListener("click", { badgeEl.remove();unselectGrp(selectedGrp.value)} )

        renderGrpTbls()

    }
}

fun unselectGrp(grpName : String) {
    currentGrp.remove(grpName)
    renderGrpTbls()
}

fun renderGrpTbls() {
    val currentTbls: Set<String> =
        currentGrp.fold(tblIDbyItem[currentItem].unsafeCast<Array<String>>().asIterable().toSet()) { tbls, grp ->
            tbls.intersect(tblIDbyGroup[grp].unsafeCast<Array<String>>().asIterable().toSet())
        }

    // Switch group enabled
    val grpElements = document.querySelectorAll("input[name='grpBtn']").asList().unsafeCast<List<HTMLInputElement>>()
    grpElements.forEach {
        if (currentGrp.contains(it.value)) {
            it.disabled = true
        } else if (tblIDbyGroup[it.value].unsafeCast<Array<String>>().intersect(currentTbls).isEmpty()) {
            it.disabled = true
        } else {
            it.disabled = false
        }
    }

    if (currentGrp.size >= 1) {
        if (currentTbls.size <= 50) {
            document.getElementById("tables")!!.innerHTML = createHTML().div("") {
                currentTbls.forEach {
                    val tblNames = tblTitles[it].unsafeCast<Array<String>>()
                    div("card") {
                        div("card-body") {
                            a("https://www.e-stat.go.jp/dbview?sid=$it", target = ATarget.blank) {
                                h5("card-title") {
                                    +tblNames[1]
                                }
                                if (tblNames[0] != "") {
                                    p("card-subtitle text-dark-emphasis") {
                                        +"表番号: ${tblNames[0]}"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } else {
            document.getElementById("tables")!!.innerHTML = createHTML().div("my-3") {
                +"(${currentTbls.size}個の表が該当)"
            }
        }
    } else {
        document.getElementById("tables")!!.innerHTML = createHTML().div("my-5") {
            br
        }
    }
}
